module.exports = __webpack_public_path__ + "static/media/farmers-logo-dark.429ed26a.svg";